export default __webpack_public_path__ + "static/media/circularTick.f8e4db04.svg";